export type AdType = {
    name: string;
    value: string;
};

export const adTypes: AdType[] = [
    {name: 'Banner', value: 'banner'},
    {name: 'MREC', value: 'mrec'},
    {name: 'Interstitial', value: 'interstitial'},
    {name: 'Native', value: 'native'},
    {name: 'Video', value: 'skippable_video'},
    {name: 'Non skippable video', value: 'non_skippable_video'},
    {name: 'Non skippable interstitial', value: 'non_skippable_interstitial'},
];
